import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * RouteAnnouncer - Announces route changes to screen readers
 * Uses aria-live to notify users when navigating between pages
 */
export const RouteAnnouncer = () => {
  const location = useLocation();
  const announceRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Get page title from the route or document title
    const getPageTitle = () => {
      // Map routes to readable titles
      const routeTitles: Record<string, string> = {
        "/": "Home",
        "/programs": "Programs",
        "/tuition": "Tuition",
        "/admissions": "Admissions",
        "/about": "About",
        "/contact": "Contact",
        "/library": "Library",
        "/privacy": "Privacy Policy",
        "/terms": "Terms of Service",
        "/auth/login": "Login",
        "/auth/signup": "Sign Up",
        "/portal": "Student Portal",
        "/admin": "Admin Dashboard",
        "/advisor/dashboard": "Advisors Dashboard",
      };

      return routeTitles[location.pathname] || "Page";
    };

    // Small delay to ensure the new page content is loaded
    const timeoutId = setTimeout(() => {
      if (announceRef.current) {
        const pageTitle = getPageTitle();
        announceRef.current.textContent = `Navigated to ${pageTitle}`;
      }
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [location.pathname]);

  return (
    <div
      ref={announceRef}
      className="sr-only"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    />
  );
};
